import { render, staticRenderFns } from "./GoodReceiptListView.vue?vue&type=template&id=ddb3c232"
import script from "./GoodReceiptListView.vue?vue&type=script&lang=js"
export * from "./GoodReceiptListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports